import { Link } from 'react-router-dom'

export const renderNav = (item: { href: string; name: string }, key: string, className: string) => {
  if (item.href && item.href.startsWith('http'))
    return (
      <a key={key} href={item.href} target="_blank" className={className}>
        <span dangerouslySetInnerHTML={{ __html: item.name }} />
      </a>
    )

  return (
    <Link key={key} to={item.href} className={className}>
      <span dangerouslySetInnerHTML={{ __html: item.name }} />
    </Link>
  )
}

/** A row of a header's account dropdown as the code declares it, before the company's config. */
type AccountMenuRow = { key: string; label: string; href: string }

/**
 * A header's account dropdown, from the company's own section under Admin > Configuration >
 * Interface. The rows are declared in code because the permission each one needs is, and a saved
 * config must not be able to hand out a screen by renaming a row; what the config decides is the
 * label, the link, the order and whether the row is offered at all.
 *
 * A key missing from the saved config keeps its declared label and slot, which is what a tenant
 * whose config predates the section gets: the backend merge fills a section in whole or not at all.
 */
export const buildAccountMenu = (rows: AccountMenuRow[], config: Record<string, any>) =>
  rows
    .map((row, index) => {
      const saved = config?.[row.key]
      return {
        key: row.key,
        label: saved?.title || row.label,
        href: saved?.link || row.href,
        visible: saved?.value !== false,
        order: saved?.order ?? index + 1,
      }
    })
    .sort((a, b) => a.order - b.order)
